import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppSettings {
  public static MAX_UPLOAD_FILE_SIZE = 5242880;
}
